<script lang="ts">
    import { getContext, onMount } from "svelte";
    import { Router, Route, useLocation, navigate } from "svelte-navigator";
    import BrandCarousel from "./catalog/BrandCarousel.svelte";
    import {
        api,
        cart,
        loader,
        config,
        isDisplayedBrandsPopup,
    } from "./stores";

    import CatalogNotFound from "./CatalogNotFound.svelte";
    import Header from "./Header.svelte";
    import Loading from "./Loading.svelte";
    import Menu from "./Menu.svelte";
    import Catalog from "./catalog/Catalog.svelte";
    import Cart from "./cart/Cart.svelte";
    import ProductMosaic from "./product/ProductMosaic.svelte";
    import ProductSheet from "./product/ProductSheet.svelte";
    import type { Operation } from "./model";
    import Searchbar from "./Searchbar.svelte";

    const { open } = getContext("simple-modal");

    const location = useLocation();
    let operation: Operation = null;
    export let catalog;
    export let shop;
    let notFound = false;

    $: $api.setLocation($location);

    onMount(async () => {
        const processId = $loader.show(
            "Chargement en cours, merci de patienter"
        );

        /**
         * cart initialization
         */
        $cart.operationCode = catalog;
        $cart.shopId = shop;
        $cart.list;

        /**
         * api initialization
         */
        $api.setOperationCode(catalog);
        $api.setShopId(shop);
        $api.getOperation().then(
            (result) => {
                operation = result;
                $loader.hide(processId);
                notFound =
                    operation &&
                    Object.keys(operation).length === 0 &&
                    Object.getPrototypeOf(operation) === Object.prototype;
                $cart.dateEnd = new Date(operation.endDate);
                $cart.cleanLocalStorage();

                if (operation.trade_brands) {
                    let listBrands = operation.trade_brands.filter(
                        (td) => td.popup_url
                    );
                    if (!$isDisplayedBrandsPopup && listBrands.length > 0) {
                        open(
                            BrandCarousel,
                            {
                                tradebrands: listBrands,
                            },
                            {
                                styleWindow: {
                                    background: "unset",
                                },
                                styleCloseButton: {
                                    display: "none",
                                },
                            }
                        );
                        $isDisplayedBrandsPopup = true;
                    }
                }
                if (!operation.show_paf) {
                    navigate(
                        "/catalog/" +
                            $api.getOperationCode() +
                            "/" +
                            $api.getShopId() +
                            "/products"
                    );
                }
            },
            (err) => {
                console.error(err);
                notFound = true;
                $loader.hide(processId);
            }
        );
    });
</script>

<Loading />

{#if !notFound}
    {#if operation !== null}
        {#if !$config.config.HideMenu}
            <Header {operation} />
            <Menu />
        {:else if !light}
            <Searchbar />
        {/if}
        <Router>
            <div
                id="main-content"
                class="{$location.pathname.split('/')[4] === 'catalog' ||
                $location.pathname.split('/').length === 4
                    ? 'bg-transparent'
                    : ''} {$config.config.HideMenu ? 'no-menu' : ''}"
                data-cs-scroll-container
            >
                <Route path="/">
                    <Catalog pageIndex={Number(1)} />
                </Route>
                <Route path="products">
                    <ProductMosaic />
                </Route>
                <Route path="products/:productId" let:params>
                    <ProductSheet productId={params.productId} />
                </Route>
                <Route path="catalog/:pageIndex" let:params>
                    <Catalog pageIndex={Number(params.pageIndex)} />
                </Route>
                <Route path="cart">
                    <Cart />
                </Route>
            </div>
        </Router>
    {/if}
{:else}
    <CatalogNotFound />
{/if}

<style lang="scss">
    @import "./styles/variables.scss";
    #main-content {
        width: $main-content-width;
        // background-color: $white;
        // background: linear-gradient(to bottom, #e3e3e3 60%, #372023 0%);
        background-size: 100% 100%;

        margin: 1rem 1rem 0rem 1rem;
        height: $main-content-height;
        // overflow-x: auto;
        float: left;
        &.bg-transparent {
            background-color: transparent;
        }
    }

    #exclusions {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: $blue;
        color: white;
        z-index: 11;

        h1 {
            font-size: 1.2em;
            margin-bottom: 5px;
            text-align: center;
        }

        #close {
            position: absolute;
            right: 5px;
            top: 5px;
            cursor: pointer;
        }

        p {
            max-height: 75px;
            overflow-y: auto;
            padding-left: 2em;
            padding-right: 2em;
            text-align: justify;
            max-width: 1500px;
            margin: auto;
            font-size: 0.8em;
        }
    }
    @media (max-width: $mobile-breakpoint) {
        #main-content {
            width: 100%;
            height: $main-content-height-mobile;
            margin: 0;
            padding: 0;
            &.no-menu {
                height: calc(100% - #{$search-mobile-height});
            }
            &.light {
                height: 100%;
            }
        }
    }
</style>
